import { StoreAction, XmAction } from 'store/actions';
import { DiscountPromoCollection } from './models';

export function discountPromotionReducer(state: DiscountPromoCollection, action: XmAction<DiscountPromoCollection>): DiscountPromoCollection {
    if (action.type === StoreAction.GET_DISCOUNT_PROMOTION) {
        return action.payload;
    }
    
    return state;
}
